import { BaseValidationRule, IValidateable, validationRule } from '@aurelia/validation';

@validationRule({
  aliases: [
    { name: 'itemSelected', defaultMessage: `\{$displayName} must match \${$rule.propertyName}.` },
  ]
})
export class ItemSelectedPropertyRule extends BaseValidationRule {
  public constructor(private propertyName: string) {
    super('itemSelected');
  }

  public execute(value: any, _object?: IValidateable): boolean {
    return typeof _object !== 'undefined' && _object?.[this.propertyName]?.itemSelected !== false
  }
}
